// src/hooks/useCart.js
import { useCart } from "../context/CartContext";

export default useCart;
